var _g, _g2, _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _circle2, _g3, _path4, _path5, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 651,
    height: 584,
    viewBox: "0 0 651 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13006_4594)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 97.0684,
    width: 515.116,
    height: 663.02,
    rx: 40.4812,
    transform: "rotate(-9.95709 11 97.0684)",
    fill: "#F6F4F4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13006_4594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9604 85.3152C70.9604 62.9581 89.0845 44.834 111.442 44.834L545.595 44.834C567.952 44.834 586.076 62.958 586.076 85.3152L586.076 667.373C586.076 689.73 567.952 707.854 545.595 707.854L111.442 707.854C89.0845 707.854 70.9604 689.73 70.9604 667.373L70.9604 85.3152Z",
    fill: "#FCFAF9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.404,
    y: 128.031,
    width: 188.706,
    height: 68.8521,
    rx: 10.1203,
    fill: "#E3E7EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.228 351.054C121.228 345.465 125.759 340.934 131.348 340.934L526.04 340.934C531.629 340.934 536.16 345.465 536.16 351.054V492.738C536.16 498.327 531.629 502.858 526.04 502.858L131.348 502.858C125.759 502.858 121.228 498.327 121.228 492.738L121.228 351.054Z",
    fill: "#EBE9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.374 446.843C281.179 446.843 278.319 446.244 275.795 445.046C273.27 443.831 271.265 442.17 269.779 440.061C268.309 437.952 267.527 435.539 267.431 432.823H276.058C276.218 434.836 277.089 436.482 278.67 437.76C280.252 439.022 282.153 439.653 284.374 439.653C286.116 439.653 287.665 439.254 289.024 438.455C290.382 437.656 291.452 436.546 292.235 435.124C293.018 433.702 293.401 432.08 293.385 430.259C293.401 428.406 293.01 426.76 292.211 425.322C291.412 423.884 290.318 422.758 288.928 421.943C287.538 421.112 285.94 420.697 284.135 420.697C282.665 420.681 281.219 420.952 279.797 421.512C278.375 422.071 277.249 422.806 276.418 423.716L268.389 422.398L270.954 397.091H299.424V404.52H278.311L276.897 417.533H277.185C278.095 416.463 279.381 415.576 281.043 414.873C282.705 414.154 284.526 413.795 286.507 413.795C289.479 413.795 292.131 414.498 294.464 415.904C296.796 417.294 298.634 419.211 299.976 421.655C301.318 424.1 301.989 426.896 301.989 430.043C301.989 433.287 301.238 436.178 299.736 438.719C298.25 441.243 296.181 443.232 293.529 444.686C290.893 446.124 287.841 446.843 284.374 446.843ZM325.909 447.107C321.963 447.107 318.576 446.108 315.748 444.111C312.936 442.098 310.771 439.198 309.253 435.411C307.752 431.609 307.001 427.032 307.001 421.679C307.017 416.327 307.776 411.774 309.277 408.019C310.795 404.248 312.96 401.373 315.772 399.392C318.6 397.41 321.979 396.42 325.909 396.42C329.84 396.42 333.219 397.41 336.047 399.392C338.875 401.373 341.04 404.248 342.541 408.019C344.059 411.79 344.818 416.343 344.818 421.679C344.818 427.048 344.059 431.633 342.541 435.435C341.04 439.222 338.875 442.114 336.047 444.111C333.235 446.108 329.856 447.107 325.909 447.107ZM325.909 439.605C328.977 439.605 331.397 438.096 333.171 435.076C334.96 432.04 335.855 427.575 335.855 421.679C335.855 417.781 335.448 414.506 334.633 411.853C333.818 409.201 332.668 407.204 331.182 405.862C329.696 404.504 327.938 403.825 325.909 403.825C322.858 403.825 320.445 405.343 318.672 408.379C316.898 411.398 316.004 415.832 315.988 421.679C315.972 425.594 316.363 428.885 317.162 431.553C317.977 434.221 319.127 436.234 320.613 437.592C322.099 438.934 323.864 439.605 325.909 439.605ZM368.673 447.107C364.726 447.107 361.339 446.108 358.511 444.111C355.7 442.098 353.535 439.198 352.017 435.411C350.515 431.609 349.764 427.032 349.764 421.679C349.78 416.327 350.539 411.774 352.041 408.019C353.559 404.248 355.723 401.373 358.535 399.392C361.363 397.41 364.742 396.42 368.673 396.42C372.603 396.42 375.982 397.41 378.81 399.392C381.638 401.373 383.803 404.248 385.305 408.019C386.823 411.79 387.581 416.343 387.581 421.679C387.581 427.048 386.823 431.633 385.305 435.435C383.803 439.222 381.638 442.114 378.81 444.111C375.998 446.108 372.619 447.107 368.673 447.107ZM368.673 439.605C371.74 439.605 374.161 438.096 375.934 435.076C377.724 432.04 378.618 427.575 378.618 421.679C378.618 417.781 378.211 414.506 377.396 411.853C376.581 409.201 375.431 407.204 373.945 405.862C372.459 404.504 370.702 403.825 368.673 403.825C365.621 403.825 363.209 405.343 361.435 408.379C359.662 411.398 358.767 415.832 358.751 421.679C358.735 425.594 359.127 428.885 359.925 431.553C360.74 434.221 361.891 436.234 363.376 437.592C364.862 438.934 366.628 439.605 368.673 439.605Z",
    fill: "#B0B7C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M455.115 492.366C455.115 486.777 459.646 482.246 465.235 482.246H525.957C531.546 482.246 536.077 486.777 536.077 492.366V529.474C536.077 535.063 531.546 539.594 525.957 539.594H465.235C459.646 539.594 455.115 535.063 455.115 529.474V492.366Z",
    fill: "#EBE9E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 117.762,
    y: 252.852,
    width: 188.706,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117.762,
    y: 279.838,
    width: 131.564,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 350.53,
    y: 252.852,
    width: 57.3484,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 455.106,
    y: 252.852,
    width: 80.9624,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 350.53,
    y: 279.838,
    width: 40.4812,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 455.106,
    y: 279.838,
    width: 60.7218,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9839,
    y: 65.3633,
    width: 473.53,
    height: 164.217,
    rx: 27.658,
    fill: "#D0D7E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13006_4594",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 118,
    width: 480,
    height: 112
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7344,
    y: 118.229,
    width: 479.154,
    height: 111.353,
    rx: 27.658,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13006_4594)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 329.839,
    cy: 304.598,
    r: 177.118,
    fill: "#3158F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13006_4594",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 127,
    width: 355,
    height: 355
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 329.839,
    cy: 304.6,
    r: 177.118,
    fill: "#3158F2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13006_4594)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.712 138.682C364.416 135.904 378.462 132.894 385.022 131.736C412.42 138.682 470.687 173.643 484.579 257.918C460.268 257.918 471.845 282.228 469.529 294.962C464.065 325.017 449.464 304.995 444.062 291.489C441.746 274.125 429.707 259.076 418.594 263.706C407.48 268.337 388.495 261.777 380.392 257.918C373.832 256.375 362.564 255.371 369.973 263.706C377.382 272.041 388.495 275.668 393.126 276.44C411.262 279.913 412.805 290.332 388.495 297.278C333.232 313.067 327.141 256.761 328.298 247.499C329.225 240.091 311.706 232.836 302.831 230.135C286.624 219.716 297.042 210.455 302.831 208.14C309.098 205.633 323.668 211.613 328.298 203.509C332.003 197.027 327.527 193.863 324.826 193.091C320.581 191.933 308.387 193.091 293.569 206.982C275.047 224.347 256.525 201.194 255.368 200.037C254.21 198.879 250.737 194.248 244.949 195.406C240.318 196.332 234.53 195.792 232.215 195.406C226.427 194.248 227.584 188.46 231.057 184.987C234.332 181.713 249.194 177.27 256.525 175.726C265.4 175.34 285.698 171.096 295.885 157.204C306.072 143.313 324.826 139.068 332.929 138.682C340.646 139.84 357.008 141.46 360.712 138.682Z",
    fill: "#0E38DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.585 196.562C191.69 195.636 179.73 209.296 175.487 216.242C171.782 218.094 171.628 222.416 172.014 224.345C173.866 228.976 178.188 226.274 180.117 224.345C181.275 221.644 186.832 216.936 199.797 219.714C212.762 222.493 217.547 216.242 218.319 212.769C219.864 207.752 219.48 197.488 205.585 196.562Z",
    fill: "#0E38DC"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.133 60.5057C288.695 70.0685 294.068 83.0385 294.068 96.5623C294.068 110.086 288.695 123.056 279.133 132.619L251.573 160.179C246.88 164.871 239.272 164.871 234.579 160.179L207.019 132.619C197.456 123.056 192.084 110.086 192.084 96.5621C192.084 83.0382 197.456 70.0683 207.019 60.5054C216.582 50.9426 229.552 45.5703 243.076 45.5703C256.6 45.5703 269.57 50.9428 279.133 60.5057Z",
    fill: "#2D374B",
    stroke: "#2D374B",
    strokeWidth: 9.57392,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.075 98.0644C223.075 87.0187 232.029 78.0645 243.075 78.0645C254.12 78.0645 263.075 87.0187 263.075 98.0644C263.075 109.11 254.12 118.064 243.075 118.064C232.029 118.064 223.075 109.11 223.075 98.0644Z",
    fill: "#FCFAF9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 247.931,
    cy: 187.583,
    rx: 24.9986,
    ry: 9.04204,
    fill: "#2D374B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13006_4594",
    x: 0.516129,
    y: 0.889075,
    width: 649.715,
    height: 769.817,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.37343,
    dy: 6.74687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.1203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13006_4594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13006_4594",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13006_4594",
    x: 57.4667,
    y: 31.3402,
    width: 555.597,
    height: 703.501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.74687,
    dy: 6.74687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.1203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13006_4594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13006_4594",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/server-error.07f150e992219153aca60e7f7e748e76.svg";
export { ForwardRef as ReactComponent };